export enum DatasetImportStatusEnum {
	OK = "OK",
	TRANSFER_ERROR = "TRANSFER_ERROR",
	DEFAULT_ERROR = "DEFAULT_ERROR",
}
